/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { IncidentReportRelationFromJSON, IncidentReportRelationToJSON, } from './IncidentReportRelation';
/**
 * Check if a given object implements the IncidentReportRelationEntityCursorPageResponse interface.
 */
export function instanceOfIncidentReportRelationEntityCursorPageResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function IncidentReportRelationEntityCursorPageResponseFromJSON(json) {
    return IncidentReportRelationEntityCursorPageResponseFromJSONTyped(json, false);
}
export function IncidentReportRelationEntityCursorPageResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'count': !exists(json, 'count') ? undefined : json['count'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : json['items'].map(IncidentReportRelationFromJSON)),
    };
}
export function IncidentReportRelationEntityCursorPageResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'count': value.count,
        'totalCount': value.totalCount,
        'next': value.next,
        'previous': value.previous,
        'items': value.items === undefined ? undefined : (value.items === null ? null : value.items.map(IncidentReportRelationToJSON)),
    };
}
